import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { CREATE_EXAMINATION_CENTER, CREATING_EXAMINATION_CENTER, DELETE_EXAMINATION_CENTER, DELETING_EXAMINATION_CENTER, EXAMINATION_CENTERS_ERROR, GETTING_EXAMINATION_CENTERS, GET_EXAMINATION_CENTERS, UPDATE_EXAMINATION_CENTER, UPDATING_EXAMINATION_CENTER } from "../types"


export const createExaminationCenter = (documentRequestPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_EXAMINATION_CENTER,
            payload: true
        })

        const response = await axios.post(`${baseUrl}/examination-centers`, documentRequestPayload, { headers })
        
        dispatch({
            type: CREATE_EXAMINATION_CENTER,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: EXAMINATION_CENTERS_ERROR,
            error
        })
    }
}

export const deleteExaminationCenter = (examinationCenterId) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: DELETING_EXAMINATION_CENTER,
            payload: true
        })

        const response = await axios.delete(`${baseUrl}/examination-centers/${examinationCenterId}`, { headers })
        
        dispatch({
            type: DELETE_EXAMINATION_CENTER,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: EXAMINATION_CENTERS_ERROR,
            error
        })
    }
}

export const updateExaminationCenter = (examinationCenterId, examinationCenterPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_EXAMINATION_CENTER,
            payload: true
        })

        const response = await axios.patch(`${baseUrl}/examination-centers/${examinationCenterId}`, examinationCenterPayload, { headers })
        
        dispatch({
            type: UPDATE_EXAMINATION_CENTER,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: EXAMINATION_CENTERS_ERROR,
            error
        })
    }
}

export const fetchExaminationCenters = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/examination-centers`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_EXAMINATION_CENTERS,
            payload: true
        })

        const response = await axios.get(url, { headers })
        // console.log(response.data.data)
        dispatch({
            type: GET_EXAMINATION_CENTERS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: EXAMINATION_CENTERS_ERROR,
            error
        })
    }
}

export const clearCreatedExaminationCenter = () => async (dispatch) => {    
    dispatch({
        type: CREATE_EXAMINATION_CENTER,
        payload: null
    })   
}

export const clearUpdatedExaminationCenter = () => async (dispatch) => {    
    dispatch({
        type: UPDATE_EXAMINATION_CENTER,
        payload: null
    })   
}

export const clearDeletedExaminationCenter = () => async (dispatch) => {    
    dispatch({
        type: DELETE_EXAMINATION_CENTER,
        payload: null
    })   
}